<template>
  <page layout="tabbed">
    <page-header-new :title="pageTitle" />
    <page-tabs :tabs="tabs" />
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
import PageTabs from '@/common/components/page/PageTabs'
import { projectRoute } from '@/core/helpers'

export default {
  name: 'EmailSavedRowsPage',
  components: { PageTabs, PageHeaderNew, Page },
  computed: {
    pageTitle() {
      return (
        this.$store.getters.embeddedTitle || this.$t('EmailRows_Page_Title')
      )
    },
    showSyncedTab() {
      return this.$can('EmailSavedRows::Read')
    },
    tabs() {
      const tabs = [
        {
          title: this.$t('EmailRows_Tab_Saved'),
          route: projectRoute({ name: 'EmailRowsSaved' })
        }
      ]
      if (this.showSyncedTab) {
        tabs.push({
          title: this.$t('EmailRows_Tab_Synced'),
          route: projectRoute({ name: 'EmailRowsSynced' })
        })
      }
      return tabs
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/email-saved-rows/pages/EmailRowsPage.vue